import { render, staticRenderFns } from "./NovoProduto.vue?vue&type=template&id=5ea05f04"
import script from "./NovoProduto.vue?vue&type=script&lang=ts"
export * from "./NovoProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports